import Declined from './Declined';
import LenderReview from './LenderReview';
import SignDocuments from './SignDocuments';

const Propensio = {
  LenderReview,
  SignDocuments,
  Declined,
};

export default Propensio;
